window.addEventListener('DOMContentLoaded', () => {
  const accSingleTriggers = document.querySelectorAll('.js-acc-single-trigger');

  accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));

  function toggleAccordion() {
    const items = document.querySelectorAll('.js-acc-item');
    const thisItem = this ? this.parentNode : null;

    items.forEach(item => {
      const content = item.querySelector('.accordion-single-content');
      if (thisItem && thisItem == item) {
        const isOpen = item.classList.toggle('is-open');
        if (isOpen) {
          // Rozwinięcie - ustaw max-height na wysokość zawartości
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          // Zwinięcie - ustaw max-height na 0
          content.style.maxHeight = null;
        }
      } else {
        // Zamknięcie innych elementów
        item.classList.remove('is-open');
        const content = item.querySelector('.accordion-single-content');
        content.style.maxHeight = null;
      }
    });
  }

  // Przed otwarciem pierwszego elementu ustaw max-height
  document.querySelectorAll('.js-acc-item').forEach(item => {
    if (item.classList.contains('is-open')) {
      const content = item.querySelector('.accordion-single-content');
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  });

  // Otwórz pierwszy element domyślnie (jeśli chcesz)
  const firstItem = document.querySelector('.js-acc-item');
  if (firstItem) {
    firstItem.classList.add('is-open');
    const content = firstItem.querySelector('.accordion-single-content');
    content.style.maxHeight = content.scrollHeight + 'px';
  }
});
